import {Route, Routes} from "react-router-dom";
import RouteScreen from "./RouteScreen";
import React from "react";
import TickingFormScreen from "../Ticking/TickingFormScreen";
import TickingScreen from "../Ticking/TickingScreen";
import {PWAUrlsParams} from "../../config/urls";

export default function MultipitchLayout() {
    return (
        <Routes>
            <Route path={'/' + PWAUrlsParams.approach.en} element={<RouteScreen approach={true}/>}/>
            <Route path={'/' + PWAUrlsParams.approach.fr} element={<RouteScreen approach={true}/>}/>
            <Route path={'/' + PWAUrlsParams.details.en} element={<RouteScreen details={true}/>}/>
            <Route path={'/' + PWAUrlsParams.details.fr} element={<RouteScreen details={true}/>}/>

            <Route path={'/' + PWAUrlsParams.ticking.en + '/' + PWAUrlsParams.crudCreate.en} element={<TickingFormScreen/>}/>
            <Route path={'/' + PWAUrlsParams.ticking.fr + '/' + PWAUrlsParams.crudCreate.fr} element={<TickingFormScreen/>}/>

            <Route path={'/' + PWAUrlsParams.ticking.en + '/' + PWAUrlsParams.crudEdit.en + '/:tickingId'} element={<TickingFormScreen/>}/>
            <Route path={'/' + PWAUrlsParams.ticking.fr + '/' + PWAUrlsParams.crudEdit.fr + '/:tickingId'} element={<TickingFormScreen/>}/>

            <Route path={'/' + PWAUrlsParams.ticking.en + '/' + PWAUrlsParams.crudView.en + '/:tickingId'} element={<TickingScreen/>}/>
            <Route path={'/' + PWAUrlsParams.ticking.fr + '/' + PWAUrlsParams.crudView.fr + '/:tickingId'} element={<TickingScreen/>}/>
            
            <Route path={`/`} element={<RouteScreen details={false}/>} />
        </Routes>
    );
}